import React from 'react';
import { CustomDateBox }
    from "Flow2/components/CustomCollections/CustomBox/CustomDataBox/CustomDataBox";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import StoreHelper from 'Flow2/components/Article/Helpers/StoreHelper';
import './DateBox.scss'

class DateBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customDataObjects: {}
        }
    }

    onDateChange = (name, date) => {
        try {
            const { customDataObjects } = this.state;
            let localDate = DataUtil.changeTime(date);
            this.setState({ [name]: localDate, customDataObjects: { ...customDataObjects, [name]: localDate } });
            if (this.props.freeType && this.props.updateCallback) {
                this.props.updateCallback(name, date);
            } else {
                StoreHelper.checkAndUpdateDataObj({
                    updateDataObjects: this.props.updateDataObjects,
                    mainObj: this.props.mainObj, subObjName: this.props.subObjName,
                    name: name, value: localDate
                });
            }
        } catch (error) {
            console.log("ERROR: onDateChange!");
        }
    };

    setUpSavedData = () => {
        const { current, item } = this.props;
        if (current) {
            const { customDataObjects } = this.state;
            this.setState({
                [`${item.name}`]: current,
                customDataObjects: { ...customDataObjects, [`${item.name}`]: current }
            });
        }

    }

    componentDidUpdate(prev) {
        if (prev.current != this.props.current) this.setUpSavedData();
    }

    componentDidMount() {
        this.setUpSavedData();
    }

    render() {
        const { item } = this.props;
        return (<div className="DateBox"><CustomDateBox uiConfig={this.props.uiConfig ? this.props.uiConfig : null}
            fMsgId={item.intl} mandatory={item.mandatory} requiredField={this.props.isRequired}
            name={item.name} selectedDate={this.state.customDataObjects[item.name]} datePos={this.props.datePos}
            onChangeDate={this.onDateChange.bind(this, item.name)} lg={this.props.lg} hideLabel={this.props.hideLabel}
            minDate={item.minDate ? item.minDate : null} maxDate={item.maxDate ? item.maxDate : null} /></div>)
    }
}



export default DateBox;